export default "__VITE_ASSET__BGVnADgf__"